/**
 * Der Abfrage-Zwischenspeicher der Oberflaeche (TanStack Query).
 *
 * Eigene Datei, damit ein Test genau diese Einstellungen pruefen kann -- und
 * nicht eine Abschrift davon, die irgendwann auseinanderlaeuft.
 */

import { QueryClient } from "@tanstack/react-query";

export function abfragenAnlegen(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Im Lager wechselt der Bestand langsam, das Netz aber schnell. Lieber
        // einmal zu viel aus dem Zwischenspeicher als ein leerer Bildschirm.
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Eine Mutation schreibt hier nur in die lokale Warteschlange -- sie
        // braucht kein Netz. Der Standard ("online") haelt sie ohne Netz an,
        // bevor sie ueberhaupt laeuft: kein Fehler, keine Meldung, die
        // Buchung einfach nicht da. Uebertragen ist Sache der Warteschlange.
        networkMode: "always",
      },
    },
  });
}
